import axios from "axios";
import { APIConstants, APILimit } from "../../constants/ApiConstants";

export const getReceipts = async (filters: string) => {
  let baseURl = `${process.env.REACT_APP_API_URL}${APIConstants.v2Receipts}${APILimit}`;
  if (filters) {
    baseURl += `&${filters}`;
  }
  const response = await axios.get(`${baseURl}`);
  return response?.data;
};

export const getPendingReceipts = async (filters?: string) => {
  let baseURl = `${process.env.REACT_APP_API_URL_PHASE_2}${APIConstants.pendingReceipts}`;
  if (filters) {
    baseURl += `?${filters}`;
  }
  baseURl += `&includeFraudBypasses=true`;
  const response = await axios.get(`${baseURl}`);
  return response?.data;
};
export const getReceiptFraudCheck = async ({
  memberId,
  merchantId,
  amount,
  purchaseDateMs,
  receiptId,
  loyaltyCardNo,
}: {
  memberId?: string;
  merchantId?: string;
  amount?: string | number;
  purchaseDateMs?: string | number;
  receiptId?: string;
  loyaltyCardNo?: string;
}) => {
  const params = new URLSearchParams({
    module: "receipts",
    feature: "receipts",
  });
  if (merchantId) params.set("merchant", merchantId);
  if (amount !== undefined && amount !== null && `${amount}` !== "") {
    params.set("amount", String(amount));
  }
  if (
    purchaseDateMs !== undefined &&
    purchaseDateMs !== null &&
    `${purchaseDateMs}` !== ""
  ) {
    params.set("purchaseDateMs", String(purchaseDateMs));
  }
  if (receiptId) {
    params.set("receiptId", receiptId);
  } else if (memberId) {
    params.set("memberId", memberId);
  }
  if (loyaltyCardNo) params.set("loyaltyCardNo", loyaltyCardNo);

  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}${APIConstants.fraudDetect}?${params.toString()}`,
  );
  return response?.data;
};
